import { delay, fork, put, call, select, takeLatest } from 'redux-saga/effects';

import { TaskActions } from "../constants/tasks";
import { createShowErrorAction, createShowSuccessAction } from "../actions/notifications";
import apiSettings from '../config/apiSettings';
import { selectProfile } from '../reducers/auth';
import { getAccessTokenEffect } from './helpers';
import * as taskActions from "../actions/tasks";

import api from '../server/tasks';

const setTaskListsAction = taskActions.createSetTaskListsAction();
const showErrorAction = createShowErrorAction();
const showSuccessAction = createShowSuccessAction();
const setTaskListLoading = taskActions.createTaskListsLoadingAction();
const setSubscribeLoading = taskActions.createSubscribeLoadingAction();

export function* getTaskListsEffect(action) {
  try {
    yield put(setTaskListLoading(true));
    yield delay(500);
    const accessToken = yield call(getAccessTokenEffect, apiSettings.scopes);
    const profile = yield select(selectProfile);
    const result = yield call(api.getTaskListsViaApi, profile.id, accessToken);
    
    if (result) {
      yield put(setTaskListsAction(result.data));  
    } else {
      yield put(showErrorAction(`Can't get task lists`));
      yield put(setTaskListsAction(null));  
    }
    yield put(setTaskListLoading(false));
  } catch (e) {
    yield put(showErrorAction(`Can't get task lists, error "${e.message}"`));
    yield put(setTaskListLoading(false));
    yield put(setTaskListsAction(null)); 
  }
}

export function* subscribeTaskListEffect(action) {
  try {
    yield put(setSubscribeLoading(true));
    const accessToken = yield call(getAccessTokenEffect, apiSettings.scopes);
    const profile = yield select(selectProfile);
    action.payload.UserId = profile.id;
    const result = yield call(api.subscribeTaskListViaApi, action.payload, accessToken);
    
    if (result) {
      yield put(showSuccessAction(`Task list setup succeeded. It can take up to 10 sec for synch in tasks.`));
      yield delay(2000);
      yield fork(getTaskListsEffect);
    } else {
      yield put(showErrorAction('Task list setup failed'));
    }
    yield put(setSubscribeLoading(false));
  } catch (e) {
    yield put(showErrorAction(`Task list setup failed, error "${e.message}"`));
    yield put(setSubscribeLoading(false));
  }
}

export default [
    takeLatest(TaskActions.GetTaskLists, getTaskListsEffect),
    takeLatest(TaskActions.SubscribeTaskList, subscribeTaskListEffect),
];